/**
 * ------------------------------------------------------------------------
 * PAGE TRANSITION JS
 * ------------------------------------------------------------------------
 */

/**
 * Variables
 * @type {Element}
 */
const layerLoading = document.querySelector('.js-layer-loading');
const layerTransition = document.querySelector('.js-layer-transition');
const layerOpacity = document.querySelector('.js-layer-opacity');

/**
 * Page transition function
 */
const pageTransition = () => {

    gsap.to(layerTransition, {
        duration: 1,
        translateY: '-100%',
        autoRound: false,
        ease: 'Power4.easeOut',
        onComplete() {
            layerTransition.remove();
        }
    });

    gsap.to(layerOpacity, {
        duration: 1.5,
        delay: .2,
        opacity: 0,
        autoRound: false,
        ease: 'Power4.easeOut',
        onComplete() {
            layerOpacity.remove();
        }
    });

    gsap.to(layerLoading, {
        duration: .2,
        opacity: 0,
        autoRound: false,
        ease: 'Power4.easeOut',
        onComplete() {
            layerLoading.remove();
        }
    });
};

window.addEventListener('load', () => {
    pageTransition();
});